import { Flex, Button, Text } from "@chakra-ui/react";
import { DisruptedCTAProps } from "../DisruptedCTA";

const BUTTON_PRIMARY_TEXT = "Continue";
const BUTTON_SECONDARY_TEXT = "Change flight details";
const QUESTION_TEXT = "Did we get it wrong?";

function QuestionCTA2({ t, onAnotherClaimReasonClick, onSubmit, isSubmitting }: DisruptedCTAProps) {
  return (
    <Flex direction={{ base: "column-reverse", md: "row" }} gap="4">
      <Button
        size="l"
        variant="secondary"
        onClick={onAnotherClaimReasonClick}
        disabled={isSubmitting}
        data-testid="claim-flight-for-another-reason-button"
      >
        {BUTTON_SECONDARY_TEXT}
      </Button>
      <Text fontSize="sm" color="greyscale.600" textAlign="center" mt="2">
        {QUESTION_TEXT}
      </Text>
      <Button
        size="l"
        onClick={onSubmit}
        isLoading={isSubmitting}
        data-testid="claim-flight-button"
      >
        <span>{BUTTON_PRIMARY_TEXT}</span>
      </Button>
    </Flex>
  );
}

export default QuestionCTA2;
